<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-container
    class="pa-2 pb-0 d-flex flex-column"
    style="height: 100%"
  >
    <div class="d-flex align-center py-4">
      <back-button @close="$emit('close')"/>
      <div>
        <div class="text-h3 font-weight-bold">
          {{ $t('changeSort') }}
        </div>

        {{ $t('dragToSort') }}
      </div>

      <v-spacer/>
      <v-btn
        color="primary"
        elevation="0"
        @click="save"
      >
        <v-icon
          left
          size="20"
        >
          mdi-content-save
        </v-icon>
        {{ $t('save') }}
      </v-btn>
    </div>

    <div
      class="mt-4 flex-grow-1"
      style="overflow-y: scroll"
    >
      <draggable
        v-model="realList"
        handle=".handle"
        style="display: grid;grid-template-columns: repeat(7,minmax(0,1fr));grid-gap: 4px"
      >
        <v-card
          v-for="item in realList"
          :key="item[itemId]"
          class="pa-2 mb-1"
          outlined
        >
          <v-responsive
            aspect-ratio="1"
            style="position: relative"
          >
            <div
              class="d-flex align-center justify-center flex-column"
              style="height: 100%;"
            >
              <v-icon
                class="handle"
                small
              >
                mdi-drag
              </v-icon>
              <div
                class="text-body-2 text-center"
                style="max-lines: 3;overflow: hidden;height:40px;text-overflow: ellipsis;line-clamp: 2;word-break: break-all"
              >
                {{ item[itemText] }}
              </div>
            </div>
          </v-responsive>
        </v-card>
      </draggable>
    </div>
  </v-container>
</template>

<script>
  import draggable from 'vuedraggable'
  import PageHeader from '@/composable/InK/typography/PageHeader'
  import BackButton from '@/composable/InK/BackButton'

  export default {
    name: 'SortFragment',
    components: {
      BackButton,
      PageHeader,
      draggable,
    },
    props: {
      initialList: {
        type: Array,
      },
      itemText: {
        default: 'name',
        type: String,
      },
      itemId: {
        default: 'id',
        type: String,
      },
      itemSort: {
        default: 'sort',
        type: String,
      },
    },
    data: function () {
      return {
        realList: [],
      }
    },
    watch: {
      initialList: {
        immediate: true,
        handler (val) {
          if (this.initialList?.length) {
            this.realList = this.initialList
            console.log(this.realList, 'Real List in sort')
          }
        },

      },
    },
    methods: {
      save () {
        this.$emit('save', this.realList)
      },
    },
  }
</script>

<style scoped>

</style>
